module.exports = __webpack_public_path__ + "static/media/water.7f9befc9.jpg";